export const apiBase = (version?: string) =>
  `/api/${version || process.env.REACT_APP_API_VERSION || 'v1'}`;
